/* SwiftNet coverage map + plan recommender
 * Data: FCC Broadband Data Collection, mobile broadband H3 hexagons (AT&T 130077,
 * Verizon 131425, T-Mobile 130403), Dec 31 2025 filing. 4G LTE 5/1 and 5G-NR 7/1,
 * outdoor stationary + in-vehicle (best of the two). Aggregated to H3 res-7 cells.
 * File format "SNCV" v1 (gzip): magic(4) ver(u32) n(u32) keys[n](u32) then
 * n * 2401 cells * 3 carriers bytes. Byte = any(0-7) | good(0-7)<<3 | fiveG(0-3)<<6
 * where any = share of area covered, good = share with signal >= -100 dBm, fiveG = share with 5G.
 */
(function () {
  'use strict';
  var root = document.querySelector('[data-sncm]');
  if (!root) return;
  var CFG = JSON.parse(root.querySelector('[data-sncm-config]').textContent);
  var CARRIERS = ['AT&T', 'Verizon', 'T-Mobile'];
  var CARRIER_OPT = ['AT&T', 'Verizon', 'T-Mobile'];
  var LEVEL_NAME = ['No coverage', 'Weak', 'Fair', 'Strong'];
  var COLORS = { 3: '#15803d', 2: '#84cc16', 1: '#f59e0b' };

  var $ = function (s) { return root.querySelector(s); };
  var $$ = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };
  var state = { use: 'home', layer: 'best', point: null, result: null, rec: null, place: null };

  /* ---------- data ---------- */
  var DATA = null, KIDX = null, BASE = 0, dataPromise = null;
  function loadData() {
    if (dataPromise) return dataPromise;
    dataPromise = fetch(CFG.dataUrl).then(function (r) {
      if (!r.ok) throw new Error('data ' + r.status);
      return r.arrayBuffer();
    }).then(function (buf) {
      var u = new Uint8Array(buf);
      if (u[0] === 0x1f && u[1] === 0x8b) {
        return new Response(new Blob([u]).stream().pipeThrough(new DecompressionStream('gzip'))).arrayBuffer();
      }
      return buf;
    }).then(function (buf) {
      var dv = new DataView(buf);
      var n = dv.getUint32(8, true);
      KIDX = new Map();
      for (var i = 0; i < n; i++) KIDX.set(dv.getUint32(12 + i * 4, true), i);
      BASE = 12 + n * 4;
      DATA = new Uint8Array(buf);
    });
    return dataPromise;
  }
  var P = []; for (var k = 0; k < 64; k++) P[k] = Math.pow(2, k);
  function decode(cell) { // -> {key, digits[1..15]}
    var L = cell.length, N = 0;
    for (var i = 0; i < L - 4; i++) N = N * 16 + parseInt(cell[i], 16);
    var d = [0];
    for (var r = 1; r <= 7; r++) d.push(Math.floor(N / P[29 - 3 * r]) & 7);
    var base = Math.floor(N / P[29]) & 127;
    return { key: base * 512 + d[1] * 64 + d[2] * 8 + d[3], d: d };
  }
  function lvl(b) {
    var any = b & 7, good = (b >> 3) & 7;
    if (good >= 5) return 3;
    if (good >= 2 || any >= 4) return 2;
    if (any >= 1) return 1;
    return 0;
  }
  function cellBytes(cell7) {
    var x = decode(cell7), ci = KIDX.get(x.key);
    if (ci === undefined) return [0, 0, 0];
    var idx = ((x.d[4] * 7 + x.d[5]) * 7 + x.d[6]) * 7 + x.d[7];
    var o = BASE + ci * 7203 + idx * 3;
    return [DATA[o], DATA[o + 1], DATA[o + 2]];
  }

  /* ---------- map ---------- */
  var map, canvasLayer, marker, boundaryCache = new Map(), aggCache = new Map();
  function resForZoom(z) { return z <= 5 ? 4 : z <= 7 ? 5 : z <= 9 ? 6 : 7; }
  function levelFor(bytes3) {
    if (state.layer === 'best') return Math.max(lvl(bytes3[0]), lvl(bytes3[1]), lvl(bytes3[2]));
    return lvl(bytes3[+state.layer]);
  }
  function aggregate(ci, sub, span) { // mean level over res-7 cells [sub*span, (sub+1)*span)
    var ck = state.layer + ':' + ci + ':' + sub + ':' + span;
    var v = aggCache.get(ck);
    if (v !== undefined) return v;
    var o = BASE + ci * 7203, s = 0, start = sub * span;
    for (var i = start; i < start + span; i++) {
      var p = o + i * 3;
      s += levelFor([DATA[p], DATA[p + 1], DATA[p + 2]]);
    }
    v = s / span; aggCache.set(ck, v); return v;
  }
  var CanvasHex;
  function defineLayer() { CanvasHex = L.Layer.extend({
    onAdd: function (m) {
      this._c = L.DomUtil.create('canvas', 'sncm-hexcanvas');
      m.getPanes().overlayPane.appendChild(this._c);
      m.on('moveend zoomend resize', this._draw, this);
      this._draw();
    },
    onRemove: function (m) { L.DomUtil.remove(this._c); m.off('moveend zoomend resize', this._draw, this); },
    redraw: function () { this._draw(); },
    _draw: function () {
      if (!DATA || !map) return;
      var m = map, size = m.getSize(), c = this._c, dpr = window.devicePixelRatio || 1;
      if (!size.x || !size.y) return;
      var tl = m.containerPointToLayerPoint([0, 0]);
      L.DomUtil.setPosition(c, tl);
      c.width = size.x * dpr; c.height = size.y * dpr;
      c.style.width = size.x + 'px'; c.style.height = size.y + 'px';
      var ctx = c.getContext('2d'); ctx.setTransform(dpr, 0, 0, dpr, 0, 0); ctx.clearRect(0, 0, size.x, size.y);
      var b = m.getBounds().pad(0.05);
      var s = Math.max(b.getSouth(), 15), n = Math.min(b.getNorth(), 72);
      var w = Math.max(b.getWest(), -179.9), e = Math.min(b.getEast(), -60);
      if (s >= n || w >= e) return;
      var parents;
      try { parents = h3.polygonToCells([[s, w], [s, e], [n, e], [n, w], [s, w]], 3); } catch (err) { parents = []; }
      // polygonToCells only returns cells whose centre is inside the view; add the cells under a grid of sample points
      var seen = new Set(parents);
      for (var gy = 0; gy <= 8; gy++) for (var gx = 0; gx <= 8; gx++) {
        var c3 = h3.latLngToCell(s + (n - s) * gy / 8, w + (e - w) * gx / 8, 3);
        if (!seen.has(c3)) { seen.add(c3); parents.push(c3); }
      }
      var r = resForZoom(m.getZoom()), drawn = 0;
      while (r > 4 && parents.length * Math.pow(7, r - 3) > 30000) r--; // never draw more than ~30k cells
      var span = Math.pow(7, 7 - r);
      ctx.globalAlpha = 0.55;
      for (var i = 0; i < parents.length; i++) {
        var pk = decode(parents[i]).key, ci = KIDX.get(pk);
        if (ci === undefined) continue;
        var kids = r === 3 ? [parents[i]] : h3.cellToChildren(parents[i], r);
        for (var j = 0; j < kids.length; j++) {
          var x = decode(kids[j]), sub = 0;
          for (var q = 4; q <= r; q++) sub = sub * 7 + x.d[q];
          var a = aggregate(ci, sub, span), L3 = Math.round(a);
          if (L3 < 1) continue;
          var bd = boundaryCache.get(kids[j]);
          if (!bd) { bd = h3.cellToBoundary(kids[j]); boundaryCache.set(kids[j], bd); }
          ctx.fillStyle = COLORS[L3];
          ctx.beginPath();
          for (var t = 0; t < bd.length; t++) {
            var pt = m.latLngToContainerPoint([bd[t][0], bd[t][1]]);
            if (t === 0) ctx.moveTo(pt.x, pt.y); else ctx.lineTo(pt.x, pt.y);
          }
          ctx.closePath(); ctx.fill();
          if (++drawn > 40000) return;
        }
      }
    }
  }); }

  function initMap() {
    if (map) return;
    defineLayer();
    map = L.map($('[data-sncm-map]'), { zoomControl: true, scrollWheelZoom: false, minZoom: 3, maxZoom: 13 })
      .setView([39.5, -98.35], 4);
    L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 19,
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &middot; Coverage: FCC BDC'
    }).addTo(map);
    map.on('focus click', function () { map.scrollWheelZoom.enable(); });
    map.on('click', function (ev) { checkPoint(ev.latlng.lat, ev.latlng.lng, null); });
    setStatus('Loading coverage data...');
    loadData().then(function () {
      canvasLayer = new CanvasHex(); canvasLayer.addTo(map); setStatus('');
    }).catch(function () { setStatus('Coverage data could not load. Call us and we will check for you.'); });
  }
  function setStatus(t) { var el = $('[data-sncm-status]'); el.textContent = t; el.hidden = !t; }

  /* ---------- lookup + recommendation ---------- */
  function geocode(q) {
    var url = 'https://nominatim.openstreetmap.org/search?format=jsonv2&countrycodes=us&limit=1&addressdetails=1&q=' + encodeURIComponent(q);
    return fetch(url, { headers: { 'Accept-Language': 'en' } }).then(function (r) { return r.json(); }).then(function (j) {
      if (!j.length) return null;
      var a = j[0].address || {};
      return { lat: +j[0].lat, lng: +j[0].lon, label: j[0].display_name, zip: a.postcode || '', city: a.city || a.town || a.village || a.hamlet || a.county || '', region: a.state || '' };
    });
  }
  function checkPoint(lat, lng, place) {
    return loadData().then(function () {
      state.point = [lat, lng]; state.place = place;
      var cell = h3.latLngToCell(lat, lng, 7), bytes = cellBytes(cell);
      state.result = bytes.map(function (b, i) {
        return { carrier: CARRIERS[i], level: lvl(b), any: b & 7, good: (b >> 3) & 7, fiveG: b >> 6 };
      });
      if (!map) initMap();
      if (marker) marker.setLatLng([lat, lng]); else marker = L.marker([lat, lng]).addTo(map);
      if (map.getZoom() < 10) map.setView([lat, lng], 11); else map.panTo([lat, lng]);
      render();
      push('coverage_check', { coverage_use: state.use, coverage_best: bestLevelName() });
    });
  }
  function bestLevelName() { return state.result ? LEVEL_NAME[Math.max.apply(null, state.result.map(function (r) { return r.level; }))] : ''; }
  function score(r) { return r.level * 100 + r.good * 10 + r.fiveG * 3 + r.any; }
  function recommend() {
    var res = state.result, best = res.slice().sort(function (a, b) { return score(b) - score(a); })[0];
    var top = best.level;
    if (top === 0) return { kind: 'none' };
    var carrier, why;
    if (state.use === 'rv') {
      carrier = 'all';
      why = 'You\'ll be on the move, so coverage changes from one stop to the next. Access to all 3 networks means you can switch to whichever carrier is strongest wherever you park.';
    } else if (top >= 2 || !CFG.homeWeakAll3) {
      carrier = CARRIERS.indexOf(best.carrier);
      why = best.carrier + ' has the strongest ' + (best.fiveG >= 2 ? '5G ' : '') + 'signal at this address, so a single-carrier plan on ' + best.carrier + ' gives you the best coverage for the lowest price.';
    } else {
      carrier = 'all';
      why = 'Every carrier is weak here, so we recommend access to all 3 networks. You can switch to whichever performs best at your address, and the 7-day money-back guarantee covers you if none of them do.';
    }
    var opt = carrier === 'all' ? CFG.allOption : CARRIER_OPT[carrier];
    var v = CFG.variants.filter(function (x) { return x.o[0] === CFG.tier && x.o[1] === opt && x.o[2] === CFG.rentOption; })[0];
    return { kind: 'plan', carrier: carrier, label: carrier === 'all' ? 'All 3 networks (AT&T, Verizon & T-Mobile)' : best.carrier + ' network', variant: v, why: why };
  }

  /* ---------- render ---------- */
  function render() {
    var out = $('[data-sncm-result]');
    if (!state.result) { out.hidden = true; return; }
    out.hidden = false; $('[data-sncm-empty]').hidden = true;
    $('[data-sncm-where]').textContent = state.place ? state.place.label.split(',').slice(0, 3).join(',') : 'Selected point on the map';
    $('[data-sncm-rows]').innerHTML = state.result.map(function (r) {
      var pct = Math.round(r.good / 7 * 100);
      return '<div class="sncm-row sncm-l' + r.level + '"><span class="sncm-carrier">' + r.carrier + '</span>' +
        '<span class="sncm-bar"><i style="width:' + Math.max(r.level ? 8 : 0, Math.round((r.level / 3) * 100)) + '%"></i></span>' +
        '<span class="sncm-lvl">' + LEVEL_NAME[r.level] + (r.fiveG >= 2 ? ' <b class="sncm-5g">5G</b>' : r.fiveG === 1 ? ' <b class="sncm-5g sncm-5g-p">5G nearby</b>' : '') + '</span></div>';
    }).join('');
    var rec = state.rec = recommend(), box = $('[data-sncm-rec]');
    if (rec.kind === 'none') {
      box.innerHTML = '<p class="sncm-rec-h">No carrier reports coverage here</p><p>The FCC data shows no AT&T, Verizon or T-Mobile coverage at this spot. We don\'t want to sell you something that won\'t work. Call <a href="tel:' + CFG.phone.replace(/\D/g, '') + '">' + CFG.phone + '</a> and we\'ll check nearby options with you.</p>';
    } else {
      var v = rec.variant, price = v ? '$' + (v.p / 100).toFixed(2) : '';
      box.innerHTML = '<p class="sncm-eyebrow">Our recommendation</p><p class="sncm-rec-h">5G Diamond &middot; ' + rec.label + '</p>' +
        '<p class="sncm-price">' + (price ? price + '<span>/mo ' + CFG.tierLabel + '</span>' : '') + '</p>' +
        '<p class="sncm-why">' + rec.why + '</p>' +
        '<a class="sncm-btn" data-sncm-cta href="' + CFG.productUrl + (v ? '?variant=' + v.id : '') + '">See this plan</a>' +
        '<p class="sncm-fine">Router rental $15/mo after your 7-day money-back guarantee, or buy it for $349. You can change the data amount on the next page.</p>';
      var cta = box.querySelector('[data-sncm-cta]');
      cta.addEventListener('click', function () { push('coverage_plan_click', { coverage_plan: rec.label }); });
    }
    $('[data-sncm-lead]').hidden = false;
    $('[data-sncm-lead-done]').hidden = true;
  }

  /* ---------- lead capture (Klaviyo client API) ---------- */
  function e164(p) { var d = (p || '').replace(/\D/g, ''); if (d.length === 10) return '+1' + d; if (d.length === 11 && d[0] === '1') return '+' + d; return ''; }
  function submitLead(ev) {
    ev.preventDefault();
    var f = ev.target, email = f.email.value.trim(), phone = e164(f.phone.value), sms = f.sms.checked && !!phone;
    var err = $('[data-sncm-lead-err]'); err.textContent = '';
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) { err.textContent = 'Please enter a valid email.'; return; }
    if (f.phone.value.trim() && !phone) { err.textContent = 'Please enter a 10-digit US phone number, or leave it blank.'; return; }
    if (f.sms.checked && !phone) { err.textContent = 'Add a phone number to get texts, or untick the box.'; return; }
    var r = state.result || [], rec = state.rec || {}, pl = state.place || {};
    var props = {
      'Internet For': state.use === 'rv' ? 'RV' : 'Home',
      'Coverage AT&T': r[0] ? LEVEL_NAME[r[0].level] : '',
      'Coverage Verizon': r[1] ? LEVEL_NAME[r[1].level] : '',
      'Coverage T-Mobile': r[2] ? LEVEL_NAME[r[2].level] : '',
      'Coverage 5G': r.some(function (x) { return x.fiveG >= 2; }) ? 'Yes' : 'No',
      'Coverage Recommended Plan': rec.kind === 'plan' ? '5G Diamond - ' + rec.label : 'None - no coverage',
      'Coverage Recommended Variant': rec.variant ? String(rec.variant.id) : '',
      'Coverage Address': pl.label || (state.point ? state.point.join(',') : ''),
      'Coverage Checked At': new Date().toISOString(),
      'Coverage Plan URL': rec.variant ? location.origin + CFG.productUrl + '?variant=' + rec.variant.id : '',
      'Coverage Plan Price': rec.variant ? '$' + (rec.variant.p / 100).toFixed(2) + '/mo ' + CFG.tierLabel : '',
      'Coverage Plan Why': rec.why || ''
    };
    var profile = { email: email, first_name: f.first_name.value.trim() || undefined, properties: props,
      location: { zip: pl.zip || undefined, city: pl.city || undefined, region: pl.region || undefined, country: 'United States',
        latitude: state.point ? state.point[0] : undefined, longitude: state.point ? state.point[1] : undefined } };
    if (phone) profile.phone_number = phone;
    // Client subscriptions API: consent is implied per identifier sent (email always; phone only when SMS box is ticked).
    var subProfile = { email: email }; if (sms) subProfile.phone_number = phone;
    var H = { 'Content-Type': 'application/vnd.api+json', 'Accept': 'application/vnd.api+json', 'revision': '2024-10-15' };
    var btn = f.querySelector('button'); btn.disabled = true; btn.textContent = 'Sending...';
    var base = 'https://a.klaviyo.com/client/';
    var q = '?company_id=' + encodeURIComponent(CFG.klaviyoKey);
    // Event first (sets phone/address on the profile), then the list signup, so anything triggered by the list sees complete data.
    var post = function (path, body) { return fetch(base + path + q, { method: 'POST', headers: H, body: JSON.stringify(body) }); };
    var rs = [];
    post('events/', { data: { type: 'event', attributes: {
        properties: props, metric: { data: { type: 'metric', attributes: { name: 'Coverage Checked' } } },
        profile: { data: { type: 'profile', attributes: profile } } } } })
    .then(function (r1) { rs.push(r1);
      return post('subscriptions/', { data: { type: 'subscription', attributes: {
        custom_source: 'Coverage Map', profile: { data: { type: 'profile', attributes: subProfile } } },
        relationships: { list: { data: { type: 'list', id: CFG.klaviyoList } } } } }); })
    .then(function (r2) { rs.push(r2);
      if (!rs.every(function (x) { return x.ok; })) throw new Error('klaviyo');
      f.hidden = true; $('[data-sncm-lead-done]').hidden = false;
      push('coverage_lead', { coverage_use: state.use, coverage_sms: sms });
    }).catch(function () {
      err.textContent = 'Something went wrong. Please try again, or call ' + CFG.phone + '.';
    }).then(function () { btn.disabled = false; btn.textContent = 'Send my report'; });
  }

  function push(event, data) { try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: event }, data)); } catch (e) {} }

  /* ---------- wiring ---------- */
  $$('[data-sncm-use]').forEach(function (b) {
    b.addEventListener('click', function () {
      state.use = b.getAttribute('data-sncm-use');
      $$('[data-sncm-use]').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      if (state.result) render();
    });
  });
  $$('[data-sncm-layer]').forEach(function (b) {
    b.addEventListener('click', function () {
      state.layer = b.getAttribute('data-sncm-layer'); aggCache.clear();
      $$('[data-sncm-layer]').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      if (canvasLayer) canvasLayer.redraw();
    });
  });
  $('[data-sncm-search]').addEventListener('submit', function (ev) {
    ev.preventDefault();
    var q = ev.target.q.value.trim(); if (!q) return;
    setStatus('Finding that address...');
    geocode(q).then(function (p) {
      if (!p) { setStatus('We couldn\'t find that address. Try adding the city and state, or tap the map.'); return; }
      setStatus(''); return checkPoint(p.lat, p.lng, p);
    }).catch(function () { setStatus('Address search is unavailable right now. Tap your location on the map instead.'); });
  });
  var geo = $('[data-sncm-geo]');
  if (!navigator.geolocation) geo.hidden = true;
  geo.addEventListener('click', function () {
    setStatus('Getting your location...');
    navigator.geolocation.getCurrentPosition(function (pos) {
      setStatus(''); checkPoint(pos.coords.latitude, pos.coords.longitude, { label: 'Your current location' });
    }, function () { setStatus('Location permission was declined. Type an address instead.'); }, { enableHighAccuracy: false, timeout: 10000 });
  });
  $('[data-sncm-lead]').addEventListener('submit', submitLead);

  // Load the map when it scrolls near the viewport (keeps the 3 MB data file off the critical path).
  function boot() { if (window.L && window.h3) initMap(); else setTimeout(boot, 100); }
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { io.disconnect(); boot(); } }, { rootMargin: '400px' });
    io.observe($('[data-sncm-map]'));
  } else boot();
})();
